import axiosConfig from '../axiosConfig';
import store from "../storeConfig";

import axios from "axios";
import getEnvVars from "../../enviroment";
import { Auth } from "aws-amplify";

const baseURL = getEnvVars().apiUrl;

export function resetOnlineOffers() {
    store.dispatch({type: "RESET_ONLINE_OFFERS"});
}

export function resetInstoreOffers() {
    store.dispatch({type: "RESET_INSTORE_OFFERS"});
}

export function getSingleOnlineOffer(offerId = 0) {
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        if (offerId === 0) {
            // shield
            return;
        }

        try {
            let paramsArr = {
                offerNumber: offerId
            }
            axi.get('offers/online', {params: paramsArr}).then((result) => {
                const newOffer = result.data;

                // console.log(result);
                store.dispatch({
                    type: 'LOAD_SINGLE_ONLINE_OFFER',
                    newOffer: newOffer
                });
                return true;
            });
        } catch (err) {
            // console.log("Network Error: ", err);
        }

    });
}

export function unloadSingleOnlineOffer() {
    store.dispatch({
        type: 'DISABLE_SINGLE_ONLINE_OFFER'
    });
}

export function webGetOnlineOffers(category = '', searchQuery = '') {
    console.log("ping");
    var axi = axios.create({
        baseURL: baseURL,
        withCredentials: false,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    });
    const cur_page      = store.getState().offers.onlineLoadedPage;
    const cur_offers    = store.getState().offers.onlineOffers || [];

    // console.log (store.getState().offers.onlineLoadedPage);

    if (cur_page === -1) {
        // weird?
        // console.log('current page not loaded?');
        return;
    }

    try {
        let paramsArr = {
            page: cur_page+1
        }
        if (category != ''){
            paramsArr.category = category
        }
        if (searchQuery != '') {
            paramsArr.searchQuery = searchQuery
        }
        axi.get('offers/webOnline', {params: paramsArr}).then((result) => {
            if(result.data.pageNumber < cur_page) {
                // stale data ERROR CASE
                // console.log('stale data from pokitpal');
                return;
            }

            const newOffers = cur_offers.concat(result.data.records);

            // console.log(result);
            store.dispatch({
                type: 'LOAD_ONLINE_OFFERS',
                newOffers: newOffers,
                currentPage: result.data.pageNumber
            });
            return true;
        });
    } catch (err) {
        console.log("Network Error: ", err);
    }
}

export function getOnlineOffers(category = '', searchQuery = '') {
    // takes array and adds balance data
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        const cur_page      = store.getState().offers.onlineLoadedPage;
        const cur_offers    = store.getState().offers.onlineOffers || [];

        // console.log (store.getState().offers.onlineLoadedPage);

        if (cur_page === -1) {
            // weird?
            // console.log('current page not loaded?');
            return;
        }

        try {
            let paramsArr = {
                page: cur_page+1
            }
            if (category != ''){
                paramsArr.category = category
            }
            if (searchQuery != '') {
                paramsArr.searchQuery = searchQuery
            }
            axi.get('offers/online', {params: paramsArr}).then((result) => {
                if(result.data.pageNumber < cur_page) {
                    // stale data ERROR CASE
                    // console.log('stale data from pokitpal');
                    return;
                }

                const newOffers = cur_offers.concat(result.data.records);

                // console.log(result);
                store.dispatch({
                    type: 'LOAD_ONLINE_OFFERS',
                    newOffers: newOffers,
                    currentPage: result.data.pageNumber
                });
                return true;
            });
        } catch (err) {
            // console.log("Network Error: ", err);
        }

    });
}

export function getSingleInstoreOffer(offerId = 0) {
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        if (offerId === 0) {
            // shield
            return;
        }

        try {
            let paramsArr = {
                offerNumber: offerId
            }
            axi.get('offers/instore', {params: paramsArr}).then((result) => {
                const newOffer = result.data;

                // console.log(result);
                store.dispatch({
                    type: 'LOAD_SINGLE_INSTORE_OFFER',
                    newOffer: newOffer
                });
                return true;
            });
        } catch (err) {
            // console.log("Network Error: ", err);
        }

    });
}

export function unloadSingleInstoreOffer() {
    store.dispatch({
        type: 'DISABLE_SINGLE_INSTORE_OFFER'
    });
}


export function webGetInstoreOffers(category = '', searchQuery = '', userLat = 0, userLng = 0) {
// takes array and adds balance data
    var axi = axios.create({
        baseURL: baseURL,
        withCredentials: false,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    });

    const cur_page      = store.getState().offers.instoreLoadedPage;
    const cur_offers    = store.getState().offers.instoreOffers || [];

    // console.log (store.getState().offers.instoreLoadedPage);

    if (cur_page === -1) {
        // weird?
        // console.log('current page not loaded?');
        return;
    }

    try {
        let paramsArr = {
            page: cur_page+1
        }
        if (category != ''){
            paramsArr.category = category
        }
        if (searchQuery != '') {
            paramsArr.searchQuery = searchQuery
        }
        if (userLat != 0 && userLng != 0) {
            paramsArr.latitude = userLat;
            paramsArr.longitude = userLng;
        }
        axi.get('offers/webInstore', {params: paramsArr}).then((result) => {
            if(result.data.pageNumber < cur_page) {
                // stale data ERROR CASE
                // console.log('stale data from pokitpal');
                return;
            }

            const newOffers = cur_offers.concat(result.data.records);

            // console.log(result);
            store.dispatch({
                type: 'LOAD_INSTORE_OFFERS',
                newOffers: newOffers,
                currentPage: result.data.pageNumber
            });
            return true;
        });
    } catch (err) {
        // console.log("Network Error: ", err);
    }
}


export function getInstoreOffers(category = '', searchQuery = '', userLat = 0, userLng = 0) {
    // takes array and adds balance data
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        const cur_page      = store.getState().offers.instoreLoadedPage;
        const cur_offers    = store.getState().offers.instoreOffers || [];

        // console.log (store.getState().offers.instoreLoadedPage);

        if (cur_page === -1) {
            // weird?
            // console.log('current page not loaded?');
            return;
        }

        try {
            let paramsArr = {
                page: cur_page+1
            }
            if (category != ''){
                paramsArr.category = category
            }
            if (searchQuery != '') {
                paramsArr.searchQuery = searchQuery
            }
            if (userLat != 0 && userLng != 0) {
                paramsArr.latitude = userLat;
                paramsArr.longitude = userLng;
            }
            axi.get('offers/instore', {params: paramsArr}).then((result) => {
                if(result.data.pageNumber < cur_page) {
                    // stale data ERROR CASE
                    // console.log('stale data from pokitpal');
                    return;
                }

                const newOffers = cur_offers.concat(result.data.records);

                // console.log(result);
                store.dispatch({
                    type: 'LOAD_INSTORE_OFFERS',
                    newOffers: newOffers,
                    currentPage: result.data.pageNumber
                });
                return true;
            });
        } catch (err) {
            // console.log("Network Error: ", err);
        }

    });
}

export function webLoadOfferCategories() {
    var axi = axios.create({
        baseURL: baseURL,
        withCredentials: false,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    });

    try {
        axi.get('offers/webCategories').then((result) => {
            if(!result.data.categories) {
                // stale data ERROR CASE
                // console.log('category fetch error?');
                return;
            }
            
            const categories = result.data.categories;
            // console.log(result);
            store.dispatch({
                type: 'LOAD_OFFER_CATEGORIES',
                categories: categories
            });
            return true;
        });
    } catch (err) {
        // console.log("Network Error: ", err);
    }
}

export function loadOfferCategories() {
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        try {
            axi.get('offers/categories').then((result) => {
                if(!result.data.categories) {
                    // stale data ERROR CASE
                    // console.log('category fetch error?');
                    return;
                }
                
                const categories = result.data.categories;
                // console.log(result);
                store.dispatch({
                    type: 'LOAD_OFFER_CATEGORIES',
                    categories: categories
                });
                return true;
            });
        } catch (err) {
            // console.log("Network Error: ", err);
        }

    });
}

export function loadFeaturedOffers() {
    // takes array and adds balance data
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        const cur_page      = store.getState().offers.onlineLoadedPage;
        const cur_offers    = store.getState().offers.onlineOffers || [];

        // console.log (store.getState().offers.onlineLoadedPage);

        if (cur_page === -1) {
            // weird?
            //('current page not loaded?');
            return;
        }

        try {
            axi.get('offers/featured').then((result) => {
                // if(result.data.pageNumber < cur_page) {
                //     // stale data ERROR CASE
                //     console.log('stale data from pokitpal');
                //     return;
                // }

                const newOffers = result.data.trendingOffers;

                // console.log(result);
                store.dispatch({
                    type: 'LOAD_FEATURED_OFFERS',
                    newOffers: newOffers
                });
                return true;
            });
        } catch (err) {
            // console.log("Network Error: ", err);
        }

    });
}

export function loadFavoriteOffers() {
    // takes array and adds balance data
    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        try {
            axi.get('offers/favourite').then((result) => {
                // if(result.data.pageNumber < cur_page) {
                //     // stale data ERROR CASE
                //     // console.log('stale data from pokitpal');
                //     return;
                // }

                const newOffers = result.data.favourites;

                // console.log(result);
                store.dispatch({
                    type: 'LOAD_FAVORED_OFFERS',
                    newOffers: newOffers
                });
                return true;
            });
        } catch (err) {
            // console.log("Network Error: ", err);
        }

    });
}

export function toggleFavoriteOffer(offerId) {
    // takes array and adds balance data

    if (offerId === undefined) {
        return;
    }

    Auth.currentSession().then((cognitoUserSession) => {
        var axi = axios.create({
            baseURL: baseURL,
            withCredentials: false,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
            }
        });

        try {
            axi.post('offers/favourite?offerNumber='.concat(offerId)).then((result) => {
                // TODO : update state
                // console.log(result);
                // const newOffers = result.data.favourites;

                // console.log(result);
                store.dispatch({
                    type: 'UNSET_FAVORITE_LOAD'
                });
                return true;
            });
        } catch (err) {
            // console.log("Network Error: ", err);
        }

    });
}